import { sortBy } from 'lodash';

export default function formatBlankAnswer(wordAssociations, answerFor) {
  const parts = [];
  let previousPosition;
  for (const association of sortBy(wordAssociations, 'position')) {
    const value = answerFor(association);
    const answer = typeof value === 'string' ? value.trim() : '';
    if (!answer) continue;
    if (parts.length && association.position !== previousPosition + 1) parts.push('...');
    parts.push(answer);
    previousPosition = association.position;
  }
  return parts.join(' ');
}
